const formatPhoneNumber = (phoneNumber) => {
  // Format the phone number to a more readable format if it's not empty
  return phoneNumber
    ? phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")
    : "";
};

export default formatPhoneNumber;
